export const groupByDataToFormValue = (groupByValues) => {
  switch (groupByValues?.type) {
    case 'interval': return `${groupByValues.count}${groupByValues.timeDimension}`;
    case 'frequency': return groupByValues.frequency;
    default: return undefined;
  }
};
